export const Stats = {
    PROMO_CODE: 0,
    REFERERS: 1,
    ACIVE_REFEERS: 2,
    CUMULATIVE_INCOME: 3,
    AVAILABLE_BALANCE: 4,
};
